module.exports = __webpack_public_path__ + "static/logos-462a1297d99e4a1d1aaf3e4148344855.png";